module.exports = __webpack_public_path__ + "static/media/register-ill3.329f34c2.svg";